// extracted by mini-css-extract-plugin
export var mermaid = "Mermaid-module--mermaid--b4645";